// ProfessionaltNotes.jsx

// Components
import TextEditorNotesHomepage from '@/components/data/common/text/TextEditorNotesHomepage';

// Services
import { updateProfessionalNotes, deleteProfessionalNotes } from '@/services/schedulingService';

const ProfessionalNotesHomepage = ({ professionalID, professionalNotes, onChange }) => {
  async function deleteNotes() {
    await deleteProfessionalNotes(professionalID);
    onChange?.('');
  }

  async function updateNotes(notes) {
    await updateProfessionalNotes(professionalID, notes);
    onChange?.(notes);
  }

  return <TextEditorNotesHomepage value={professionalNotes} updateText={updateNotes} deleteText={deleteNotes}></TextEditorNotesHomepage>;
};

export default ProfessionalNotesHomepage;
